import ModalFormWrapper from "../common/ModalFormWrapper";
import HomeRepayCreditFormStablecoin from "../forms/HomeRepayCreditFormStablecoin";
import {AvailableBalance} from "../../utils/creditService";

interface HomeRepayCreditModalViewStablecoinProps {
  onCloseModal: () => void;
  handleBack: () => void;
  creditLine: AvailableBalance;
}

function HomeRepayCreditModalViewStablecoin(
  {
    onCloseModal,
    handleBack,
    creditLine,
  }:HomeRepayCreditModalViewStablecoinProps) {
  return (
    <ModalFormWrapper
      headerTitle="Repay with stablecoin"
      onClick={handleBack}
      onCloseModal={onCloseModal}
    >

      <HomeRepayCreditFormStablecoin creditLine={creditLine}/>

    </ModalFormWrapper>
  );
}

export default HomeRepayCreditModalViewStablecoin;